import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center pt-20 px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full text-center"
      >
        <span className="text-xs tracking-[0.3em] uppercase text-zinc-500 block mb-6">Checkout cancelled</span>
        <h1 className="font-display text-5xl md:text-6xl text-white tracking-tighter leading-none mb-6">
          No <em className="text-[#D4AF37]">rush.</em>
        </h1>
        <p className="text-sm text-zinc-400 mb-10">
          Your card was not charged. The photograph will be waiting whenever you are ready.
        </p>
        <Link
          to="/gallery"
          data-testid="cancel-back-link"
          className="inline-flex items-center gap-3 border border-white/25 text-white text-xs tracking-[0.25em] uppercase font-semibold px-12 py-5 hover:border-white transition-colors duration-300"
        >
          <ArrowLeft size={15} /> Return to the gallery
        </Link>
      </motion.div>
    </div>
  );
}
